<template>
    <div v-if="!isAuthenticated" id="login-pane" class="container ">
        <div class="parallax" data-inverted="true" data-speed="0.02" data-initial-offset="9" style=";">
            <card class="text-left pb-2 col-sm-12 login-card parallax-item float-md-right">
                <template slot="body">
                    <h2 class="display-1 montserrat-bold mb-0">Log in</h2>
                    <p class="text-muted mt--2 text-sm">Sign in to get started</p>
                    <form  @submit.prevent="login">
                        <div class="row mt-5">
                            <div class="col-12">
                                <form-input label="Email" placeholder="Email" v-model="form.email" ref="email"></form-input>
                            </div>
                            <div class="col-12">
                                <form-input label="Password" placeholder="Password" type="password" v-model="form.password" ref="password"></form-input>
                            </div>
                            <div class="col-12 remember-me-wrapper mb-3">
                                <checkbox class="inline-block"></checkbox>
                                <span class="remember-me-text">Remember me</span>
                            </div>
                            <div class="col-12 text-right">
                                <button v-if="!isLoading" type="submit" :class="styleClass.loginButton">
                                    <i class="fas fa-sign-in-alt mr-1"></i> Log in
                                </button>
                                <button v-else disabled class="btn btn-warning disabled">
                                    <i class="fas fa-spinner fa-spin mr-1"></i> Please wait
                                </button>
                            </div>
                            <div v-if="!areTPCookiesEnabled" class="col-12 text-left text-white bg-danger pt-2 pb-2 pl-4 pr-4 mt-3">
                                <span class="font-weight-700">Something went wrong.</span> Please make sure the cookies are enabled and refresh the page to log in.
                            </div>
                        </div>
                    </form>
                    <div class="row">
                        <div class="col-12 mt-3">
                            <div>Don't have an account? 
                                <router-link to="/sign-up" v-slot="{ href, navigate }">
                                    <a :href="href" @click="navigate" class="link-hover-line">Register here</a>
                                </router-link>
                            </div>

                            <div>
                                <a :href="forgotPasswordPage" target="_blank" class="link-hover-line">Forgot password</a>
                            </div>
                            
                        </div>
                        <div class="col-12 text-center mt-5">
                            <div class="text-muted mb-3">Or log in with</div>
                            <div style="display:none">
                                <v-facebook-login v-model="facebookModel" @sdk-init="handleFacebookInit" @login="loginFacebook" ref="facebookButton" :app-id="facebookID"></v-facebook-login>
                                <google-login :params="googleParams" :onSuccess="loginGoogle" :onFailure="googleLoginFailed" ref="googleButton" :logoutButton="false">Login</google-login>
                            </div>
                            <!-- <a href="facebook-sign-in" @click.prevent="$refs.facebookButton.$el.click()" :class="styleClass.fbLoginButton">
                                <i class="fab fa-facebook-f"></i>
                            </a> -->
                            <a href="google-sign-in" @click.prevent="$refs.googleButton.$el.click()" :class="styleClass.googleLoginButton">
                                <i class="fab fa-google"></i>
                            </a>
                            <a href="#" >
                            </a>
                        </div>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import { default as config } from "@src/config";
import { pageBackend } from "@utils/network";
import mixins from "@utils/mixins";
import Form from "@models/components/Form";
import VFacebookLogin from 'vue-facebook-login-component'
import GoogleLogin from 'vue-google-login';

export default {
    name: "LoginForm",

    components: { VFacebookLogin, GoogleLogin },
    
    computed: {
        facebookID() {
            return config.FACEBOOK_ID;
        },
        isAuthenticated() {
            return !!this.$store.getters.tokenKey;
        },
        styleClass() {
            return {
                loginButton: {
                    "btn btn-warning": true,
                    "disabled": !this.areTPCookiesEnabled,
                },
                fbLoginButton: {
                    "provider-login-button btn btn-facebook rounded-circle": true,
                    "disabled": !this.areTPCookiesEnabled,
                },
                googleLoginButton: {
                    "provider-login-button btn btn-google-plus rounded-circle": true,
                    "disabled": !this.areTPCookiesEnabled,
                },
            }
        }
    },

    data: () =>({
        isLoading: false,
        areTPCookiesEnabled: true,
        forgotPasswordPage: pageBackend("forgot-password"),
        form: new Form({
            email: null,
            password: null,
            provider: "email",
            provider_id: null,
        }),
        facebookModel: {
            connected:false,
            disabled: false,
            disconnected: true,
            enabled: true,
            error: null,
            hasError: false,
            idle: true,
            working: false,

        },
        fb: {},
        scope: {},
        googleParams: {
            client_id: config.GOOGLE_ID
        },
        providerForm: {
            provider: null,
            provider_id: null,
            email: null,
            firstname: null,
            lastname: null,
        }
    }),

    methods: {
        loginFacebook(payload) {
            if (!payload) return;

            const url = `/${ payload.authResponse.userID }`;
            const params = {fields: "id,email,first_name,last_name,birthday,gender"};

            this.fb.api(url, "get", params, user => {
                this.initializeProviderLogin("facebook", user.id, user.email, user.first_name, user.last_name);
                this.scope.logout();
            });
        },
        loginGoogle(googleUser) {
            const user = googleUser.getBasicProfile();
            this.initializeProviderLogin("google", user.getId(), user.getEmail(), user.getGivenName(), user.getFamilyName());
        },
        initializeProviderLogin(provider, provider_id, email, firstname, lastname) {
            this.providerForm = {provider, provider_id, email, firstname, lastname};
            this.loggedInVia(provider, provider_id);
        },
        googleLoginFailed(error) {
            console.error("Google log in failed");
            console.error(error);
            this.areTPCookiesEnabled = false;
        },
        loggedInVia(provider, provider_id) {
            this.isLoading = true;
            this.$store.dispatch("login", { provider, provider_id })
                .then(response => this.reload())
                .catch(error => {
                    if (error.response.data.result.exception != "These credentials do not match our records.") {
                        return this.promptFormErrors(this.$refs, error);
                    }
                    this.redirectToRegistration();
                })
                .finally(() => this.isLoading = false);
        },
        async login() {
            this.isLoading = true;
            this.$store.dispatch("login", {
                email: this.form.email,
                password: this.form.password,
            })
            .then(response => this.reload())
            .catch(error => this.promptFormErrors(this.$refs, error))
            .finally(() => this.isLoading = false);
        },
        handleFacebookInit({ FB, scope }) {
            this.fb = FB;
            this.scope = scope;
            this.scope.logout();
        },
        redirectToRegistration() {
            this.$router.push({ name: 'Sign up', params: { provider_data: this.providerForm } });
        }
    },
    
    mixins: [mixins],
}
</script>

<style scoped lang="css">
    #login-pane {
        text-align: right;
        margin-top: -700px;
        z-index: 10;
        position: relative;
    }
    #login-pane .provider-login-button {
        font-size: 20px;
        padding: 10px 5px;
        width: 52px;
        height: 52px;
        text-align: center;
    }
    #login-pane > .parallax {
        height: 700px;
    }
    @media (min-width: 1331px) {
        .login-card {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 41.66666667%;
            flex: 0 0 41.66666667%;
            max-width: 41.66666667%;
        }
    }
    @media (max-width: 1330px) {
        #login-pane {
            margin-top: -70px
        }
    }
</style>